module.exports = __webpack_public_path__ + "static/media/ChildProtectionPolicy.434b6d95.pdf";